import { Button } from "@/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/i18n";

const FAQSection = ({ onCtaClick }) => {
  const { t } = useLanguage();
  
  return (
    <section id="faq" className="section-surface section" data-testid="faq-section">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0F172A] mb-4 text-center">
            {t('faq.title')}
          </h2>
          <p className="text-[#475569] text-center mb-10 max-w-2xl mx-auto">
            {t('faq.description')}
          </p>

          <div className="space-y-8">
            {/* GDPR & Data Protection */}
            <div>
              <h3 className="text-lg font-semibold text-[#0F172A] mb-4 border-b border-[#E2E8F0] pb-2">
                {t('faq.categories.gdpr')}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="gdpr-1" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.gdpr1q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.gdpr1a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="gdpr-2" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.gdpr2q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.gdpr2a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="gdpr-3" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.gdpr3q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.gdpr3a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="gdpr-4" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.gdpr4q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.gdpr4a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="gdpr-5" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.gdpr5q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.gdpr5a')}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>

            {/* Resilience & Reliability */}
            <div>
              <h3 className="text-lg font-semibold text-[#0F172A] mb-4 border-b border-[#E2E8F0] pb-2">
                {t('faq.categories.resilience')}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="res-1" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.res1q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.res1a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="res-2" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.res2q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.res2a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="res-3" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.res3q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.res3a')}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>

            {/* Installation & On-Site Impact */}
            <div>
              <h3 className="text-lg font-semibold text-[#0F172A] mb-4 border-b border-[#E2E8F0] pb-2">
                {t('faq.categories.installation')}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="inst-1" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.inst1q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.inst1a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="inst-2" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.inst2q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.inst2a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="inst-3" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.inst3q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.inst3a')}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>

            {/* Staff & Patient Acceptance */}
            <div>
              <h3 className="text-lg font-semibold text-[#0F172A] mb-4 border-b border-[#E2E8F0] pb-2">
                {t('faq.categories.staff')}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="staff-1" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.staff1q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.staff1a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="staff-2" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.staff2q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.staff2a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="staff-3" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.staff3q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.staff3a')}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>

            {/* Buyers & Decision-Makers */}
            <div>
              <h3 className="text-lg font-semibold text-[#0F172A] mb-4 border-b border-[#E2E8F0] pb-2">
                {t('faq.categories.buyers')}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="buy-1" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.buy1q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.buy1a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="buy-2" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.buy2q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.buy2a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="buy-3" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.buy3q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.buy3a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="buy-4" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.buy4q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.buy4a')}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>

            {/* Scope & Expectations */}
            <div>
              <h3 className="text-lg font-semibold text-[#0F172A] mb-4 border-b border-[#E2E8F0] pb-2">
                {t('faq.categories.scope')}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="scope-1" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.scope1q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.scope1a')}
                  </AccordionContent>
                </AccordionItem>
                <AccordionItem value="scope-2" className="border-[#E2E8F0]">
                  <AccordionTrigger className="text-left text-[#0F172A] hover:no-underline hover:text-[#8B1B3A]">
                    {t('faq.questions.scope2q')}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#475569] leading-relaxed">
                    {t('faq.questions.scope2a')}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-[#0F172A] font-medium mb-6">
              {t('faq.closing')}
            </p>
            <p className="text-[#475569] mb-6">
              {t('faq.ctaText')}
            </p>
            <Button
              onClick={onCtaClick}
              className="bg-[#8B1B3A] hover:bg-[#701530] text-white px-6 py-3 h-auto text-base rounded-md"
              data-testid="faq-cta-button"
            >
              {t('faq.ctaButton')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
